import { useState, useEffect } from "react";
import { FiMenu, FiUser } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../Images/Garvana_Logo.png";
import NavigationBar from "../NavigationBar/NavigationBar";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Load user from localStorage
  useEffect(() => {
    const updateUser = () => {
      const stored = localStorage.getItem("user");
      setUser(stored ? JSON.parse(stored) : null);
    };
    updateUser();
    window.addEventListener("user-updated", updateUser);
    return () => window.removeEventListener("user-updated", updateUser);
  }, []);

  // Auto close drawer when window resized to desktop
  useEffect(() => {
    const closeOnResize = () => {
      if (window.innerWidth >= 1024) setMenuOpen(false);
    };
    window.addEventListener("resize", closeOnResize);
    return () => window.removeEventListener("resize", closeOnResize);
  }, []);

  return (
    <header className="header">

      {/* MOBILE TOGGLE (left side) */}
      <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        <FiMenu size={24} />
      </button>

      {/* DESKTOP LOGO ONLY */}
      <Link to="/" className="desktop-logo">
        <img src={Logo} alt="Garvana Logo" className="logo" />
      </Link>

      {/* DESKTOP NAVIGATION */}
      <NavigationBar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      {/* RIGHT SIDE (Login or Profile) */}
      {/* <div className="right-header">
        {!user ? (
          <Link to="/login" className="header-login-btn">
            Login
          </Link>
        ) : (
          <div
            className="desktop-profile"
            onClick={() => navigate("/profile")}
          >
            {user.profileImage ? (
              <img src={user.profileImage} className="profile-img" alt="profile" />
            ) : (
              <FiUser size={22} color="#fff" />
            )}
          </div>
        )}
      </div> */}
    </header>
  );
}
